<script lang="ts">
	import type { Design } from "luxedo-data"
	import moment from "moment"
	import { initContextMenu, type ContextMenuOptions } from "context-menu"
	import * as css from "./UserRow.module.css"

	interface Props {
		projects: Array<Design>
	}

	let { projects }: Props = $props()

	const ctxMenuOpts: ContextMenuOptions = [
		{ title: "Clone to Self", onClick: () => alert("clone to self") },
		{
			title: "Download",
			hasSubmenu: true,
			submenu: [
				{
					title: "Video",
					onClick: () => alert("download video"),
				},
				{
					title: "Audio",
					onClick: () => alert("download audio"),
				},
				{
					title: "Thumbnail",
					onClick: () => alert("download thumbnail"),
				},
			],
		},
	]

	function handleProjectClick(project, e) {
		const ctxEventHandler = initContextMenu(ctxMenuOpts)
		ctxEventHandler(e)
	}
</script>

<div class={css.info}>
	<h2>Projects</h2>
	<table>
		<thead>
			<tr>
				<th>ID</th>
				<th>Name</th>
				<th>Last Render</th>
			</tr>
		</thead>
		<tbody>
			{#each projects as project}
				{#if project}
					<tr
						class={css.row}
						onclick={(e) => handleProjectClick(project, e)}
						tabindex="0"
						role="button"
					>
						<td>{project.id}</td>
						<td>{project.name}</td>
						<td>{`${moment(project.render_ver).format(`MM/DD/YY hh:mm a`)}`}</td
						>
					</tr>
				{/if}
			{/each}
		</tbody>
	</table>
</div>

<style>
	tr td:last-of-type {
		width: 10rem;
	}
</style>
